<div class="ranking-wrapper" [class.lightTheme]="lightTheme">
  <span>
    {{ 'SHARED.WELCOME.CONNECTIVITY_RANKING.YOUR_RANK' | translate }}
  </span>
  <span>{{ rankingPositions.userPosition }}</span>
  <mat-icon [matTooltip]="'SHARED.WELCOME.CONNECTIVITY_RANKING.TOOLTIP' | translate"
    >info_outline</mat-icon
  >
</div>
